
import { RecipientTypes } from 'hellospa/page/prep-and-send/data/types';
import { TemplateResponse } from 'hellospa/app-context/actions/prep-and-send';
import { defineMessages } from 'react-intl';
import { Template } from 'generated/types/HelloRequest';

export const messages = defineMessages({
  incompatibleSignerOrder: {
    id: '',
    description: 'tooltip message for templates that are incompatible because of signer order',
    defaultMessage: 'Signer order setting is incompatible with currently selected template(s)',
  },
  incompatibleDateFormat: {
    id: '',
    description: 'tooltip message for templates that are incompatible because of date format',
    defaultMessage: 'Date format setting is incompatible with currently selected template(s)',
  },
  incompatibleSignerReassignment: {
    id: '',
    description: 'tooltip message for templates that are incompatible because of signer reassignment',
    defaultMessage: 'Signer reassignment setting is incompatible with currently selected template(s)',
  },
  incompatibleSignerRoles: {
    id: '',
    description: 'tooltip message for templates that are incompatible because of role names',
    defaultMessage: 'Signer role is incompatible with currently selected template(s)',
  },
});

export type MinimalTemplateResponse = Pick<
  TemplateResponse,
  'recipientReassignment' | 'dateFormat' | 'recipientOrder' | 'recipients'
>

const rolesAreCompatible = (first: MinimalTemplateResponse, second: Template) => {
  if (first.recipients.length === 1 && second.recipients.length === 1) {
    const firstRole = first.recipients[0];
    const secondRole = second.recipients[0];
    return firstRole.type === RecipientTypes.Role
      && secondRole.type === RecipientTypes.Role
      && firstRole.name === secondRole.name;
  }
  return false;
};

export function isDisabled(
  template: Template,
  templatesInRequest: MinimalTemplateResponse[],
  bulkSend: boolean,
) {
  // we only look at the first template because we assume only compatible templates were added
  const templateInRequest = templatesInRequest[0];
  if (templateInRequest) {
    if (template.dateFormat !== templateInRequest.dateFormat) {
      // if the date formats don't match, the template is disabled
      return { disabled: true, message: messages.incompatibleDateFormat };
    } else if (
    // cannot combine ordered templates with any other templates
      templateInRequest.recipientOrder
            || (template.recipientOrder && !templateInRequest.recipientOrder)
    ) {
      return { disabled: true, message: messages.incompatibleSignerOrder };
    } else if (
      (templateInRequest.recipientReassignment && !template.recipientReassignment)
            || (!templateInRequest.recipientReassignment && template.recipientReassignment)
    ) {
      // mismatched signer reassignment setting is also not allowed
      // logical xor would be a straight forward condition
      return {
        disabled: true,
        message: messages.incompatibleSignerReassignment,
      };
    } else if (bulkSend && !rolesAreCompatible(templateInRequest, template)) {
      return { disabled: true, message: messages.incompatibleSignerRoles };
    }
  }
  return { disabled: false };
}
